"use client";

import { getPostsFromDirectus } from "@/services/media";
import { MediaPosts } from "@/types/media";
import { useQuery } from "@tanstack/react-query";
import { ChevronRight, Loader } from "lucide-react";
import { useEffect, useState } from "react";
import AmplifyProductsCard from "./cards/amplify-products-card";
import HiringCard from "./cards/hiring-card";
import RecentBlogsCard from "./cards/recent-blogs-card";

const HiringCardData = [
	{
		iconSrc: "/news/recent-blogs/icon-1.png",
		title: "Customer Experience Designer",
		description: "Auto Nation (Remote)",
	},
	{
		iconSrc: "/news/recent-blogs/icon-2.png",
		title: "Customer Experience Designer",
		description: "Auto Nation (Remote)",
	},
	{
		iconSrc: "/news/recent-blogs/icon-3.png",
		title: "Customer Experience Designer",
		description: "Auto Nation (Remote)",
	},
];

const AmplifyProductsData = [
	{
		iconSrc: "/news/recent-blogs/icon-4.png",
		title: "Property Inspection",
		description: "Quality assessment of a property",
	},
	{
		iconSrc: "/news/recent-blogs/icon-5.png",
		title: "ListEz",
		description: "Simplifying real estate & CRM",
	},
	{
		iconSrc: "/news/recent-blogs/icon-6.png",
		title: "Agent iChat",
		description: "Real Estate Chatbot",
	},
];

const RecentBlogs = () => {
	const [recentPosts, setRecentPosts] = useState<MediaPosts>([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);

	const {
		data,
		isLoading: isRecentPostsLoading,
		isError: isRecentPostsError,
	} = useQuery({
		queryKey: ["mediaRecentPosts", currentPage],
		queryFn: () =>
			getPostsFromDirectus({
				page: currentPage,
				per_page: 5,
				type: "blog",
			}),
	});

	useEffect(() => {
		if (data) {
			setRecentPosts((prevPosts) => [...prevPosts, ...(data?.posts || [])]);

			setTotalPages(data?.totalCount || 0);
		}
	}, [data, currentPage]);

	return (
		<div className="mt-6 flex items-start justify-center gap-6 py-12 md:mt-16 md:py-12">
			<div className="mx-auto w-11/12 max-w-7xl md:w-full">
				<div className="flex flex-wrap gap-6 md:flex-nowrap">
					<div className="h-fit basis-full overflow-hidden scroll-auto rounded-lg bg-blue-500 bg-opacity-10 shadow md:sticky md:top-20 md:basis-1/3">
						<div className="m-4 rounded-md bg-white p-2 shadow">
							<h4 className="mt-2 px-4 text-sm md:text-lg">Hiring in Our Network</h4>

							{HiringCardData.map(({ iconSrc, title, description }, index) => (
								<HiringCard key={index} iconSrc={iconSrc} title={title} description={description} />
							))}

							<p className="mb-2 text-center text-xs text-gray-500">$100 for 30 days</p>
							<div className="mx-2 mb-2 px-2">
								<button className="block w-full rounded-lg border bg-brand-primary px-4 py-3 text-white shadow">
									Post a Job
								</button>
							</div>

							<div className="mx-2 mb-2 px-2">
								<button className="font-200 flex w-full items-center justify-center gap-2 rounded-lg border px-4 py-3 text-base shadow">
									View All
									<ChevronRight className="h-4 w-4" />
								</button>
							</div>
						</div>

						<div className="m-4 rounded-md bg-white p-2 shadow">
							<h4 className="text-md mt-2 px-4 font-semibold md:text-xl">
								Amplify your product <span className="text-brand-primary">Globally</span> by
								launching it here!
							</h4>
							<p className="mt-2 px-4 text-xs text-gray-500">
								Launch your products and exciting new features multiple times a year for free!
							</p>

							{AmplifyProductsData.map(({ iconSrc, title, description }, index) => (
								<AmplifyProductsCard
									key={index}
									iconSrc={iconSrc}
									title={title}
									description={description}
								/>
							))}

							<p className="font-semiold mb-2 text-center text-xs text-gray-900">
								+330 Products submited this month
							</p>
							<div className="mx-2 mb-2 px-2">
								<button className="block w-full rounded-lg border bg-brand-primary px-4 py-3 text-white shadow">
									Submit your Product
								</button>
							</div>
						</div>
					</div>

					<div className="flex basis-full flex-col items-start md:basis-2/3">
						<h2 className="mb-4 text-2xl font-bold text-gray-800">Recent Blogs</h2>

						{isRecentPostsError ? (
							<span className="text-xs font-medium text-gray-400">
								Something went wrong, could not fetch recent posts
							</span>
						) : null}

						{recentPosts.map((recentPost) => (
							<RecentBlogsCard key={recentPost.id} recentPost={recentPost} className="mb-4" />
						))}

						{!isRecentPostsLoading ? (
							currentPage < totalPages ? (
								<button
									className="mx-auto block max-h-14 w-fit rounded-lg bg-white px-6 py-3 text-center text-sm font-medium text-gray-900 disabled:opacity-40 md:text-lg"
									onClick={() => setCurrentPage((prevPage) => prevPage + 1)}
								>
									Show More
								</button>
							) : (
								<span className="text-centertext-xs mx-auto block max-h-14 w-fit px-6 py-3 font-medium text-gray-400">
									You{"'"}ve reached the end
								</span>
							)
						) : (
							<div className="w-full py-8">
								<Loader className="mx-auto h-8 w-8 animate-spin duration-300" />
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default RecentBlogs;
